import { Dispatch } from 'react-redux';
import { Moment } from 'moment';
import { OrderedMap } from 'immutable';

import { fetcher, request } from '../../lib/request';

import { CoordsPlace } from '../../models/Transfer/CoordsPlace';
import { Order, OrderInfo, Passenger } from '../../models/Transfer/Order';
import { Place } from '../../models/Transfer/Place';
import { Price } from '../../models/Transfer/Price';

const TRANSFER_HOST = process.env.REACT_APP_TRANSFER_HOST;
const TRANSFER_KEY = process.env.REACT_APP_TRANSFER_KEY;

export const GET_PLACES_REQUEST = 'TRANSFER_GET_PLACES_REQUEST';
export const GET_PLACES_RESPONSE = 'TRANSFER_GET_PLACES_RESPONSE';
export const GET_PLACES_ERROR = 'TRANSFER_GET_PLACES_ERROR';

export const GET_COORDS_PLACES_FROM_REQUEST = 'TRANSFER_GET_COORDS_PLACES_FROM_REQUEST';
export const GET_COORDS_PLACES_FROM_RESPONSE = 'TRANSFER_GET_COORDS_PLACES_FROM_RESPONSE';
export const GET_COORDS_PLACES_FROM_ERROR = 'TRANSFER_GET_COORDS_PLACES_FROM_ERROR';

export const GET_COORDS_PLACES_TO_REQUEST = 'TRANSFER_GET_COORDS_PLACES_TO_REQUEST';
export const GET_COORDS_PLACES_TO_RESPONSE = 'TRANSFER_GET_COORDS_PLACES_TO_RESPONSE';
export const GET_COORDS_PLACES_TO_ERROR = 'TRANSFER_GET_COORDS_PLACES_TO_ERROR';

export const GET_PRICES_REQUEST = 'TRANSFER_GET_PRICES_REQUEST';
export const GET_PRICES_RESPONSE = 'TRANSFER_GET_PRICES_RESPONSE';
export const GET_PRICES_ERROR = 'TRANSFER_GET_PRICES_ERROR';

export const CHECK_TIME_REQUEST = 'TRANSFER_CHECK_TIME_REQUEST';
export const CHECK_TIME_RESPONSE = 'TRANSFER_CHECK_TIME_RESPONSE';
export const CHECK_TIME_ERROR = 'TRANSFER_CHECK_TIME_ERROR';

export const ORDER_TRANSFER_REQUEST = 'TRANSFER_ORDER_TRANSFER_REQUEST';
export const ORDER_TRANSFER_RESPONSE = 'TRANSFER_ORDER_TRANSFER_RESPONSE';
export const ORDER_TRANSFER_ERROR = 'TRANSFER_ORDER_TRANSFER_ERROR';

export const GET_PAY_URL_REQUEST = 'TRANSFER_GET_PAY_URL_REQUEST';
export const GET_PAY_URL_RESPONSE = 'TRANSFER_GET_PAY_URL_RESPONSE';
export const GET_PAY_URL_ERROR = 'TRANSFER_GET_PAY_URL_ERROR';

export const REQUEST_LOG_REQUEST = 'TRANSFER_REQUEST_LOG_REQUEST';
export const REQUEST_LOG_RESPONSE = 'TRANSFER_REQUEST_LOG_RESPONSE';
export const REQUEST_LOG_ERROR = 'TRANSFER_REQUEST_LOG_ERROR';

export const SET_PLACE_FROM = 'TRANSFER_SET_PLACE_FROM';
export const SET_PLACE_TO = 'TRANSFER_SET_PLACE_TO';

export const SET_PLACE_FROM_INPUT = 'TRANSFER_SET_PLACE_FROM_INPUT';
export const SET_PLACE_TO_INPUT = 'TRANSFER_SET_PLACE_TO_INPUT';

export const RESET_PLACES = 'TRANSFER_RESET_PLACES';

export const SET_PRICE = 'TRANSFER_SET_PRICE';

export const SET_TABLE = 'TRANSFER_SET_TABLE';
export const SET_COMMENT = 'TRANSFER_SET_COMMENT';

export const SET_DATE = 'TRANSFER_SET_DATE';
export const SET_DEPARTURE_DATE = 'TRANSFER_SET_DEPARTURE_DATE';

export const SET_PASSENGERS = 'TRANSFER_SET_PASSENGERS';
export const ADD_PASSENGERS = 'TRANSFER_ADD_PASSENGERS';
export const SET_DEPARTURE_NUMBER = 'TRANSFER_SET_DEPARTURE_NUMBER';
export const SET_DEPARTURE_TRAIN_CARRIAGE_NUMBER = 'TRANSFER_SET_DEPARTURE_TRAIN_CARRIAGE_NUMBER';
export const SET_ARRIVAL_NUMBER = 'TRANSFER_SET_ARRIVAL_NUMBER';
export const SET_ARRIVAL_TRAIN_CARRIAGE_NUMBER = 'TRANSFER_SET_ARRIVAL_TRAIN_CARRIAGE_NUMBER';

export const getPlacesAction = (term: string, parent?: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_PLACES_REQUEST
    });

    try {
        const response = await fetcher(`${TRANSFER_HOST}/api/v2/places?term=${term}${parent ? `&parent=${parent}` : ''}`)
            .auth(`Basic ${TRANSFER_KEY}`)
            .json();

        dispatch({
            type: GET_PLACES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_PLACES_ERROR,
            error
        });
    }
};

export const getCoordsPlacesFromAction = (id: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_COORDS_PLACES_FROM_REQUEST
    });

    try {
        const response = await fetcher(`${TRANSFER_HOST}/api/v2/places/${id}`)
            .auth(`Basic ${TRANSFER_KEY}`)
            .json();

        dispatch({
            type: GET_COORDS_PLACES_FROM_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_COORDS_PLACES_FROM_ERROR,
            error
        });
    }
};

export const getCoordsPlacesToAction = (id: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_COORDS_PLACES_TO_REQUEST
    });

    try {
        const response = await fetcher(`${TRANSFER_HOST}/api/v2/places/${id}`)
            .auth(`Basic ${TRANSFER_KEY}`)
            .json();

        dispatch({
            type: GET_COORDS_PLACES_TO_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_COORDS_PLACES_TO_ERROR,
            error
        });
    }
};

export const getPricesAction = (startPlacePoint: CoordsPlace, finishPlacePoint: CoordsPlace) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_PRICES_REQUEST
    });

    try {
        const response = await fetcher(`${TRANSFER_HOST}/api/v2/prices?start_place_point=${startPlacePoint.lat},${startPlacePoint.lng}` +
            `&finish_place_point=${finishPlacePoint.lat},${finishPlacePoint.lng}`)
            .auth(`Basic ${TRANSFER_KEY}`)
            .json();

        dispatch({
            type: GET_PRICES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_PRICES_ERROR,
            error
        });
    }
};

export const checkTimeAction = (priceId: number, pickupTime: string, departureTime?: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CHECK_TIME_REQUEST
    });

    return request(`${process.env.REACT_APP_TRANSFER_HOST}/api/v2/orders/${priceId}/check_time` +
        `?pickup_time=${pickupTime}${departureTime ? `&departure_time=${departureTime}` : ''}`, {
        method: 'GET',
        headers: new Headers({
            'authorization': `basic ${process.env.REACT_APP_TRANSFER_KEY}`
        })
    }).then(response => dispatch({
        type: CHECK_TIME_RESPONSE,
        response: response
    })).catch(e => dispatch({
        type: CHECK_TIME_ERROR,
        error: e
    }));
};

export const orderTransferAction = (order: Order) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: ORDER_TRANSFER_REQUEST
    });

    try {
        const response = await fetcher(`${TRANSFER_HOST}/api/v2/orders`)
            .post(order)
            .contentType('application/json')
            .auth(`Basic ${TRANSFER_KEY}`)
            .json();

        dispatch({
            type: ORDER_TRANSFER_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: ORDER_TRANSFER_ERROR,
            error
        });
    }
};

export const getPayUrlAction = (transaction: number) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_PAY_URL_REQUEST
    });

    try {
        const response = await fetcher(`${TRANSFER_HOST}/api/v2/orders/${transaction}/pay_url`)
            .auth(`Basic ${TRANSFER_KEY}`)
            .json();

        dispatch({
            type: GET_PAY_URL_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_PAY_URL_ERROR,
            error
        });
    }
};

export const requestLogAction = (log: OrderInfo) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: REQUEST_LOG_REQUEST
    });

    try {
        await fetcher(`${TRANSFER_HOST}/api/v2/prices`)
            .post(log)
            .contentType('application/json')
            .auth(`Basic ${TRANSFER_KEY}`)
            .json();

        dispatch({
            type: REQUEST_LOG_RESPONSE
        });
    } catch (error) {
        dispatch({
            type: REQUEST_LOG_ERROR,
            error
        });
    }
};

export const setPlaceFromAction = (place: Place) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_PLACE_FROM,
        place
    });
};

export const setPlaceToAction = (place: Place) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_PLACE_TO,
        place
    });
};

export const setPlaceFromInputAction = (input: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_PLACE_FROM_INPUT,
        input
    });
};

export const setPlaceToInputAction = (input: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_PLACE_TO_INPUT,
        input
    });
};

export const resetPlacesAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESET_PLACES
    });
};

export const setPriceAction = (price: Price) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_PRICE,
        price
    });
};

export const setTableAction = (table: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_TABLE,
        table
    });
};

export const setCommentAction = (comment: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_COMMENT,
        comment
    });
};

export const setDateAction = (date: Moment) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_DATE,
        date
    });
};

export const setDepartureDateAction = (departureDate: Moment) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_DEPARTURE_DATE,
        departureDate
    });
};

export const setPassengersAction = (passengers: OrderedMap<number, Passenger>) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_PASSENGERS,
        passengers
    });
};

export const addPassengerAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: ADD_PASSENGERS
    });
};

export const setDepartureNumberAction = (departureNumber: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_DEPARTURE_NUMBER,
        departureNumber
    });
};

export const setArrivalNumberAction = (arrivalNumber: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_ARRIVAL_NUMBER,
        arrivalNumber
    });
};

export const setDepartureTrainCarriageNumberAction = (trainCarriageNumber: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_DEPARTURE_TRAIN_CARRIAGE_NUMBER,
        trainCarriageNumber
    });
};

export const setArrivalTrainCarriageNumberAction = (trainCarriageNumber: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: SET_ARRIVAL_TRAIN_CARRIAGE_NUMBER,
        trainCarriageNumber
    });
};



// WEBPACK FOOTER //
// ./src/actions/Transfer/transfer.ts